import { IMAGE_LIBRARY_TYPE } from "@/shared/imageLibrary/types";
import { getMenuImageUrl } from "@/shared/utils/helpers";
import { ItemImageAndTextPropertiesEnum } from "@/shared/v2/queries/interfacesV2";

export const resolveToppingImageUrl = (
  imageCloudinaryId: string | undefined | null,
  branch: number
) => {
  if (!imageCloudinaryId) return null;
  if (
    imageCloudinaryId.includes("/cms/") ||
    imageCloudinaryId.startsWith("http")
  ) {
    return imageCloudinaryId;
  }
  return getMenuImageUrl(imageCloudinaryId, branch, IMAGE_LIBRARY_TYPE.topping);
};

export const toppingCategoryHasImage = (
  itemImageAndTextProperties?: ItemImageAndTextPropertiesEnum | number | string
) => {
  const value = String(
    itemImageAndTextProperties ?? ItemImageAndTextPropertiesEnum.only_text
  );
  return (
    value === ItemImageAndTextPropertiesEnum.only_image ||
    value === ItemImageAndTextPropertiesEnum.image_and_text
  );
};
